<button mat-icon-button type="button" (click)="toggleIsFilterRowHidden()">
  @if (isFilterRowHidden()) {
    <mat-icon>filter_alt_off</mat-icon>
  } @else {
    <mat-icon>filter_alt</mat-icon>
  }
</button>
